



<div *ngIf="phoneApp">
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">Gate Activity </div>

    </div>

    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">

                    <mat-form-field class="newField myOption" style=" font-size: 17px; min-width: 95%; max-width: 95%; padding-top: 20px" appearance="outline" >
                      <mat-label style="color: #E61E00;">Search Criteria</mat-label>
                      <mat-select  [(value)]="savedList" (selectionChange)="wipeOutScreen()"   >
                        <mat-option class="myOption" *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="newField" style=" font-size: 17px; min-width: 95%; max-width: 95%;" appearance="outline" >
                      <input  [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()">
                      <mat-icon (click)="getSearchItems()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>
                    </mat-form-field>


                    <div class="errorDiv2" style="text-align: center; padding-bottom: 10px" *ngIf="submitted && didntEnterShit">Please Enter A Value</div>
                    <div class="errorDiv2" style="text-align: center; padding-bottom: 10px" *ngIf="submitted && badSearch">No Data Found</div>
                    <div class="errorDiv2" style="text-align: center; padding-bottom: 10px" *ngIf="submitted && maherError!=null">{{maherError}}</div>
                    <div class="errorDiv2" style="text-align: center; padding-bottom: 10px" *ngIf="submitted && notANumber">Visit Must Be Numeric</div>
                  </mat-card>
                </div>

                <div *ngIf="showDetailScreen">


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="status"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Gate Status</div>
                      </div>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Gate Status</mat-label>
                        <input *ngIf="gateDetail.transaction_status=='OK' || gateDetail.transaction_status=='COMPLETE'" style="color: green" [(ngModel)]="gateDetail.transaction_status" matInput readonly/>
                        <input *ngIf="gateDetail.transaction_status=='TROUBLE' || gateDetail.transaction_status=='CANCEL'"  style="color: #E61E00" [(ngModel)]="gateDetail.transaction_status" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Transaction Type</mat-label>
                        <input [(ngModel)]="gateDetail.transaction_type_description" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">


                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="visit"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Visit Details</div>
                      </div>


                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Driver Name</mat-label>
                          <input [(ngModel)]="gateDetail.driver_name" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Trucking Co.</mat-label>
                          <input [(ngModel)]="gateDetail.trucking_company_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Container</mat-label>
                          <input [(ngModel)]="gateDetail.container" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Container ISO</mat-label>
                          <input [(ngModel)]="gateDetail.container_iso_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Line Id</mat-label>
                          <input [(ngModel)]="gateDetail.line_id_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Line Op User</mat-label>
                          <input [(ngModel)]="gateDetail.ssl_operator_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Lease</mat-label>
                          <input [(ngModel)]="gateDetail.container_lease_description" matInput readonly/>
                        </mat-form-field>
                        <div *ngIf="gateDetail.transaction_type!='RE' && gateDetail.transaction_type!='DM'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Remarks</mat-label>
                          <input [(ngModel)]="gateDetail.remarks" matInput readonly/>
                        </mat-form-field>
                        </div>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Chassis</mat-label>
                          <input [(ngModel)]="gateDetail.chassis" matInput readonly/>
                        </mat-form-field>
                    </mat-card>
                  </div>



                  <div style="padding-top: 8%" *ngIf="gateDetail.transaction_type=='RE'||gateDetail.transaction_type=='DM'">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="booking"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Booking Information</div>
                      </div>


                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Booking Number</mat-label>
                          <input [(ngModel)]="gateDetail.booking" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Booking Line Op</mat-label>
                          <input [(ngModel)]="gateDetail.booking_ssl_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Booking ISO</mat-label>
                          <input [(ngModel)]="gateDetail.booking_iso_description" matInput readonly/>
                        </mat-form-field>
                        <div *ngIf="gateDetail.transaction_type=='DM'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Port Of Loading</mat-label>
                          <input [(ngModel)]="gateDetail.port_of_loading_description" matInput readonly/>
                        </mat-form-field>
                        </div>
                        <div *ngIf="gateDetail.transaction_type=='RE'">
                          <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                            <mat-label style="font-size: 20px; color: #E61E00">Port Of Discharge</mat-label>
                            <input [(ngModel)]="gateDetail.port_of_discharge_description" matInput readonly/>
                          </mat-form-field>
                        </div>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Vessel</mat-label>
                          <input [(ngModel)]="gateDetail.vessel_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Voyage</mat-label>
                          <input [(ngModel)]="gateDetail.voyage" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Remarks</mat-label>
                          <input [(ngModel)]="gateDetail.remarks" matInput readonly/>
                        </mat-form-field>
                    </mat-card>
                  </div>


                  <div style="padding-top: 8%" *ngIf="gateDetail.transaction_type=='RE'">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="weights"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Weight Information</div>
                      </div>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Scale Weight</mat-label>
                          <input [(ngModel)]="gateDetail.scale_weightFmt" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Tractor Weight</mat-label>
                          <input [(ngModel)]="gateDetail.tractor_weightFmt" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Tare Weight</mat-label>
                          <input [(ngModel)]="gateDetail.tare_weightFmt" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Chassis Weight</mat-label>
                          <input [(ngModel)]="gateDetail.chassis_weightFmt" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Gross Weight</mat-label>
                          <input [(ngModel)]="gateDetail.gross_weightFmt" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Net Weight</mat-label>
                          <input [(ngModel)]="gateDetail.net_weightFmt" matInput readonly/>
                        </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" *ngIf="gateDetail.transaction_type=='RE'">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="booth"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Gate Activity</div>
                      </div>


                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Hazardous</mat-label>
                        <input [(ngModel)]="gateDetail.hazardousFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Auto</mat-label>
                        <input [(ngModel)]="gateDetail.autoFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Roadability</mat-label>
                        <input [(ngModel)]="gateDetail.roadabilityFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Placards</mat-label>
                        <input [(ngModel)]="gateDetail.placardsFmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" *ngIf="(gateDetail.transaction_type=='RE' || gateDetail.transaction_type=='RI' || gateDetail.transaction_type=='DI' || gateDetail.transaction_type=='DE') && gateDetail.seal_verification_date!=' '">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="seals"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Seal Information</div>
                      </div>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Seal 1</mat-label>
                        <input [(ngModel)]="gateDetail.seal_1" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Seal 2</mat-label>
                        <input [(ngModel)]="gateDetail.seal_2" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Seal 3</mat-label>
                        <input [(ngModel)]="gateDetail.seal_3" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Seal 4</mat-label>
                        <input [(ngModel)]="gateDetail.seal_4" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>



                  <div style="padding-top: 8%" *ngIf="gateDetail.reefer=='1'">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="reefer"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Reefer Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Running Reefer</mat-label>
                        <input [(ngModel)]="gateDetail.reeferFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Temp. Required</mat-label>
                        <input [(ngModel)]="gateDetail.temp_required_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Humidity</mat-label>
                        <input [(ngModel)]="gateDetail.humidity_requiredFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Fuel Level</mat-label>
                        <input [(ngModel)]="gateDetail.reefer_fuel_levelFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Reefer Hours</mat-label>
                        <input [(ngModel)]="gateDetail.reefer_hours" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Genset</mat-label>
                        <input [(ngModel)]="gateDetail.genset" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Genset Type</mat-label>
                        <input [(ngModel)]="gateDetail.genset_type_description" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>


                  <div style="padding-top: 8%" *ngIf="gateDetail.is_oog=='1'">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="ods"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Over Dimensions Information</div>
                      </div>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Over Height</mat-label>
                        <input [(ngModel)]="gateDetail.over_heightFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Over Length Front</mat-label>
                        <input [(ngModel)]="gateDetail.over_length_frontFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Over Length Rear</mat-label>
                        <input [(ngModel)]="gateDetail.over_length_rearFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Over Width Left</mat-label>
                        <input [(ngModel)]="gateDetail.over_width_leftFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Over Width Right</mat-label>
                        <input [(ngModel)]="gateDetail.over_width_rightFmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" >
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="clock"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Gate Times</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Entered Yard</mat-label>
                        <input [(ngModel)]="gateDetail.entered_yard" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Lane In</mat-label>
                        <input [(ngModel)]="gateDetail.lane_in_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Lane Out</mat-label>
                        <input [(ngModel)]="gateDetail.lane_out_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Security Out</mat-label>
                        <input [(ngModel)]="gateDetail.guard_out_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Exited Yard</mat-label>
                        <input [(ngModel)]="gateDetail.exited_yard" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Cancel Date</mat-label>
                        <input [(ngModel)]="gateDetail.cancel_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Cancel Reason</mat-label>
                        <input [(ngModel)]="gateDetail.cancel_reason_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Escort</mat-label>
                        <input [(ngModel)]="gateDetail.escort_request_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Escort Reason</mat-label>
                        <input [(ngModel)]="gateDetail.escort_reason" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Problem Elapsed Time</mat-label>
                        <input [(ngModel)]="gateDetail.prob_elapsed_time" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Total Elapsed Time</mat-label>
                        <input [(ngModel)]="gateDetail.total_elapsed_time" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%; color: green">
                        <mat-label style="font-size: 20px; color: #E61E00">Stage Id</mat-label>
                        <input [(ngModel)]="gateDetail.stage_id" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>



                  <div style="padding-top: 8%" *ngIf="this.gateDetail.gateErrors!=null && this.gateDetail.gateErrors.length>0">
                    <mat-card class="iso-bubble"  style="text-align: center;background-color:rgba(23,122,241,0.07); " xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="errors"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Gate Errors</div>
                      </div>

                      <div class="flex-item2" >
                        <mat-table  [dataSource]="geData" multiTemplateDataRows matSort>
                          <ng-container matColumnDef="msg_text" >
                            <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Error</mat-header-cell>
                            <mat-cell *matCellDef="let row">{{row.msg_text}}</mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="severity" >
                            <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Severity</mat-header-cell>
                            <mat-cell *matCellDef="let row">{{row.severity}}</mat-cell>
                          </ng-container>
                          <mat-header-row *matHeaderRowDef="geColumns; sticky: true"></mat-header-row>
                          <mat-row   *matRowDef="let row; columns: geColumns;" class="table-row"></mat-row>
                        </mat-table>
                      </div>
                    </mat-card>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>


</div>



<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">


      <mat-card class="quickView" *ngIf="showQuickView">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 18%">
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 70%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/local_shipping-24px.svg" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 24%">Click On Any Row To View Details For The Visit</div>
            </td>
            <td style="width: 20%" *ngIf="ipadApp">
              <div >
                <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch2()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
              </div>
            </td>
          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
            <ng-container matColumnDef="visit" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Visit</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.visit}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="gate_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Gate</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.gate_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="transaction_type_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Transaction</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.transaction_type_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="variousCol" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{columnName}}</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.variousCol}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="driverOrTruckerCol" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{driverTruckerColName}}</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.driverOrTruckerCol}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="lane_in_date" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Entered</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.lane_in_date}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="guardOrLaneOutCol" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Exited</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.guardOrLaneOutCol}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="stage_id">
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Stage</mat-header-cell>
              <mat-cell *matCellDef="let row" class="greenFont">{{row.stage_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="next_stage_id">
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Next Stage</mat-header-cell>
              <mat-cell *matCellDef="let row" class="redFont">{{row.next_stage_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="slot">
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Slot</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.slot}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="strad_status">
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Straddle Status</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="row.strad_status=='PENDING'? 'redFont': 'greenFont' ">{{row.strad_status}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="transaction_status" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Status</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.transaction_status}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" (click)="showDetails(row)"></mat-row>
          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator" (touchstart)="dontShowSearch()" [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
              <span style="padding-left: 24%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
              </span>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>



      <mat-card class="details" *ngIf="showDetailScreen">
        <table style="width: 100%; height: 100%">
          <tr>
            <td style="width: 95%;">


              <mat-card class="contDetails">
                <table style="width: 100%">
                  <tr>
                      <div class="maher2" (click)="myApp.showCharts()"></div>
                    <td style="width: 13%">
                      <div class="titleFont" style=" font-size: 21px">Gate:<a style="color: green"> {{gateDetail.gate_description}}</a></div>
                    </td>
                    <td style="width: 14%">
                      <div class="titleFont" style="font-size: 21px">Visit:<a style="color: green"> {{gateDetail.visit}}</a></div>
                    </td>

                    <td style="width: 14%">
                      <div class="titleFont" style=" font-size: 21px;">Status:
                        <a *ngIf="gateDetail.transaction_status=='OK' || gateDetail.transaction_status=='COMPLETE'" style="color: green">{{gateDetail.transaction_status | titlecase}}</a>
                        <a *ngIf="gateDetail.transaction_status=='TROUBLE' || gateDetail.transaction_status=='CANCEL' || gateDetail.transaction_status=='CLOSED'" style="color: #E61E00">{{gateDetail.transaction_status | titlecase}}</a>
                      </div>
                    </td>

                    <td style="width: 22%">
                      <div class="titleFont" style="font-size: 21px;">Container: <a style="color: green">{{gateDetail.container}}</a></div>
                    </td>
                    <td style="width: 23%">
                      <div class="titleFont" style="font-size: 21px">Type: <a style="color: green">{{gateDetail.transaction_type_description}}</a></div>
                    </td>
                    <td style="width: 11%">
                      <div class="lowerCaseLetters" [hidden]="gateDetails.length==1" (click)="returnToQuickView()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Quick View</div>
                      <div class="lowerCaseLetters" *ngIf="gateDetails.length==1 && ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
                    </td>
                  </tr>
                </table>



                <table style="width: 100%; height: 100%; padding: 0px; margin: 0px; min-width: 100%; max-width: 100%">
                  <tr>
                    <td style="width: 85%; height: 100%; text-align: center;" >
                      <table  class="table-fill" style="height: 100%">
                        <tr>
                          <td style="vertical-align: top">
                            <div>
                              <mat-form-field appearance="outline"  >
                                <mat-label style="font-size: 18px; color: #E61E00">Reference Number</mat-label>
                                <input [(ngModel)]="gateDetail.transaction_number" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline"  >
                                <mat-label style="font-size: 18px; color: #E61E00">Driver</mat-label>
                                <input [(ngModel)]="gateDetail.driver_name" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline"  >
                                <mat-label style="font-size: 18px; color: #E61E00">Trucking Co.</mat-label>
                                <input [(ngModel)]="gateDetail.trucking_company_description" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline"  >
                                <mat-label style="font-size: 18px; color: #E61E00">Container</mat-label>
                                <input [(ngModel)]="gateDetail.container" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline"  >
                                <mat-label style="font-size: 18px; color: #E61E00">Container ISO</mat-label>
                                <input [(ngModel)]="gateDetail.container_iso_description" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline" >
                                <mat-label style="font-size: 18px; color: #E61E00">Line Op Owner</mat-label>
                                <input [(ngModel)]="gateDetail.line_id_description" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline" >
                                <mat-label style="font-size: 18px; color: #E61E00">Line Op User</mat-label>
                                <input [(ngModel)]="gateDetail.ssl_operator_description" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline" >
                                <mat-label style="font-size: 18px; color: #E61E00">Lease</mat-label>
                                <input [(ngModel)]="gateDetail.container_lease_description" matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div *ngIf="gateDetail.transaction_type!='RE' && gateDetail.transaction_type!='DM'">
                              <mat-form-field appearance="outline" >
                                <mat-label style="font-size: 18px; color: #E61E00">Remarks</mat-label>
                                <textarea style="max-height: 40px; min-height: 40px" [(ngModel)]="gateDetail.remarks" matInput readonly></textarea>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="outline" >
                                <mat-label style="font-size: 18px; color: #E61E00">Chassis</mat-label>
                                <input [(ngModel)]="gateDetail.chassis" matInput readonly/>
                              </mat-form-field>
                            </div>
                          </td>


                          <td style="vertical-align: top" *ngIf="gateDetail.transaction_type=='RE'||gateDetail.transaction_type=='DM'||gateDetail.transaction_type=='DI'">
                            <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">

                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px " *ngIf="gateDetail.transaction_type=='RE'||gateDetail.transaction_type=='DM'">Booking Info</div>
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px "*ngIf="gateDetail.transaction_type=='DI'">Vessel And Port Info</div>
                                <div style="padding-top: 2px" *ngIf="gateDetail.transaction_type!='DI'">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00" >Booking Number</mat-label>
                                    <input [(ngModel)]="gateDetail.booking"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div *ngIf="gateDetail.transaction_type!='DI'">
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00" >Booking Line Op</mat-label>
                                    <input [(ngModel)]="gateDetail.booking_ssl_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div *ngIf="gateDetail.transaction_type!='DI'">
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00" >Booking ISO</mat-label>
                                    <input [(ngModel)]="gateDetail.booking_iso_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div *ngIf="gateDetail.transaction_type=='DM' || gateDetail.transaction_type=='DI'">
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Port Of Loading</mat-label>
                                    <input [(ngModel)]="gateDetail.port_of_loading_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div *ngIf="gateDetail.transaction_type=='RE'">
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Port Of Discharge</mat-label>
                                    <input [(ngModel)]="gateDetail.port_of_discharge_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Vessel</mat-label>
                                    <input [(ngModel)]="gateDetail.vessel_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                                    <input [(ngModel)]="gateDetail.voyage" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Remarks</mat-label>
                                    <textarea style="max-height: 58px; min-height: 58px" [(ngModel)]="gateDetail.remarks" matInput readonly></textarea>
                                  </mat-form-field>
                                </div>
                              </div>


                            </div>

                          </td>


                          <td style="vertical-align: top" *ngIf="gateDetail.transaction_type=='RE'">
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px;  text-align: left; padding-left: 5%;padding-bottom: 15px ">Weight Info</div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Scale Weight</mat-label>
                                    <input [(ngModel)]="gateDetail.scale_weightFmt" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Tractor Weight</mat-label>
                                    <input [(ngModel)]="gateDetail.tractor_weightFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Chassis Weight</mat-label>
                                    <input [(ngModel)]="gateDetail.chassis_weightFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>


                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Gross Weight</mat-label>
                                    <input [(ngModel)]="gateDetail.gross_weightFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Tare Weight</mat-label>
                                    <input [(ngModel)]="gateDetail.tare_weightFmt" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Net Weight</mat-label>
                                    <input [(ngModel)]="gateDetail.net_weightFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>


                              </div>

                            </div>
                          </td>


                          <td *ngIf="(gateDetail.transaction_type=='RE') || ((gateDetail.transaction_type=='RI' || gateDetail.transaction_type=='DI' || gateDetail.transaction_type=='DE') && gateDetail.seal_verification_date!=' ')" style="vertical-align: top" style="background-color:rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%; vertical-align: top" >

                            <div *ngIf="gateDetail.transaction_type=='RE'">
                              <div  class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Gate Activity</div>
                              <div >
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Hazardous</mat-label>
                                  <input [(ngModel)]="gateDetail.hazardousFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Auto</mat-label>
                                  <input [(ngModel)]="gateDetail.autoFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Placards</mat-label>
                                  <input [(ngModel)]="gateDetail.placardsFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>

                            <div *ngIf="(gateDetail.transaction_type=='RE' || gateDetail.transaction_type=='RI' || gateDetail.transaction_type=='DI' || gateDetail.transaction_type=='DE') && gateDetail.seal_verification_date!=' '  ">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Seal Info</div>

                              <div>
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 1</mat-label>
                                  <input [(ngModel)]="gateDetail.seal_1" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 2</mat-label>
                                  <input [(ngModel)]="gateDetail.seal_2" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 3</mat-label>
                                  <input [(ngModel)]="gateDetail.seal_3" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 4</mat-label>
                                  <input [(ngModel)]="gateDetail.seal_4" matInput readonly/>
                                </mat-form-field>
                              </div>


                            </div>

                          </td>




                          <td style="vertical-align: top" *ngIf="gateDetail.reefer=='1'">
                            <div style="background-color:  rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Reefer Info</div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Running Reefer</mat-label>
                                    <input [(ngModel)]="gateDetail.reeferFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Temp. Required</mat-label>
                                    <input [(ngModel)]="gateDetail.temp_required_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Humidity</mat-label>
                                    <input [(ngModel)]="gateDetail.humidity_requiredFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Fuel Level</mat-label>
                                    <input [(ngModel)]="gateDetail.reefer_fuel_levelFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Reefer Hours</mat-label>
                                    <input [(ngModel)]="gateDetail.reefer_hours"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Genset</mat-label>
                                    <input [(ngModel)]="gateDetail.genset"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Genset Type</mat-label>
                                    <input [(ngModel)]="gateDetail.genset_type_description"  matInput readonly/>
                                  </mat-form-field>
                                </div>

                              </div>
                            </div>
                          </td>

                          <td style="vertical-align: top" *ngIf="gateDetail.is_oog=='1'">
                            <div style="background-color:  rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Over Dimensions</div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Over Height</mat-label>
                                    <input [(ngModel)]="gateDetail.over_heightFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Over Length Front</mat-label>
                                    <input [(ngModel)]="gateDetail.over_length_frontFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Over Length Rear</mat-label>
                                    <input [(ngModel)]="gateDetail.over_length_rearFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Over Width Left</mat-label>
                                    <input [(ngModel)]="gateDetail.over_width_leftFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Over Width Right</mat-label>
                                    <input [(ngModel)]="gateDetail.over_width_rightFmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>

                              </div>
                            </div>
                          </td>

                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </mat-card>



              <mat-card class="contDetails">
                <mat-toolbar mat-toolbar class="toolbar4">
                  <mat-toolbar-row style="justify-content: center">
                    <div class="lowerCaseLetters" *ngIf="gateDetails.length>1" (click)="previousTransaction()" style="font-size: 14px; color: #E61E00; cursor: pointer;">Previous Transaction</div>
                    <span style="padding-right: 4%"></span>

                    <span style="text-align: center">
              <button mat-raised-button (click)="openGateTimes()"  class="whiteButton"><img style="vertical-align: center;height:25px; width: 50px" src="assets/truck.png" > Gate Times</button>
              <span style="padding-left: 1%"></span>
              <button mat-raised-button (click)="openInspectionTimes()"  class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/Inspection.png" > Inspection Times</button>
              <span style="padding-left: 1%"></span>
              <button mat-raised-button [disabled]="gateDetail.gateErrors.length==0" (click)="openGateErrors()"  class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/troubleRed.png" > Gate Errors</button>
                <span style="padding-left: 1%"></span>
              <button mat-raised-button [disabled]="gateDetail.gateDamages.length==0" (click)="openGateDamages()"  class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/damages.png" > Gate Damages</button>
              <span style="padding-left: 1%"></span>
              <button mat-raised-button [disabled]="gateDetail.transaction_status!='COMPLETE' && gateDetail.transaction_status!='CLOSED' " (click)="getReports(gateDetail.visit)"  class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/print-24px.svg" > Reprint TIR</button>
              </span>

                    <span style="padding-left: 4%"></span>

                    <div class="lowerCaseLetters" *ngIf="gateDetails.length>1" (click)="nextTransaction()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Transaction</div>

                  </mat-toolbar-row>
                </mat-toolbar>
                <div>
                  <mat-accordion>
                    <mat-expansion-panel [(expanded)]="showAcc"  hideToggle="true">
                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showGateInfo">
                        <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Gate Times</div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>

                                <td style="vertical-align: top">
                                  <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid">
                                    <table style="width: 100%; padding-top: 15px">
                                      <tr>
                                        <td style="width: 25%">
                                          <div>
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Lane In</mat-label>
                                              <input [(ngModel)]="gateDetail.lane_in_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: left" >
                                          <div>
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Lane In By</mat-label>
                                              <input [(ngModel)]="gateDetail.lane_in_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: right">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Cancel Date</mat-label>
                                              <input [(ngModel)]="gateDetail.cancel_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Cancel By</mat-label>
                                              <input [(ngModel)]="gateDetail.cancel_by" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width: 25%">
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Lane Out</mat-label>
                                              <input [(ngModel)]="gateDetail.lane_out_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: left">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Lane Out By</mat-label>
                                              <input [(ngModel)]="gateDetail.lane_out_by" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 50%;" colspan="2">
                                          <div >
                                            <mat-form-field appearance="outline" style="min-width: 98%; ">
                                              <mat-label style="font-size: 18px; color: #E61E00">Cancel Reason</mat-label>
                                              <input [(ngModel)]="gateDetail.cancel_reason_description" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width: 25%">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Security Out</mat-label>
                                              <input [(ngModel)]="gateDetail.guard_out_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: left">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Security Out By</mat-label>
                                              <input [(ngModel)]="gateDetail.guard_out_by" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: right">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Escort</mat-label>
                                              <input [(ngModel)]="gateDetail.escort_request_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Escort By</mat-label>
                                              <input [(ngModel)]="gateDetail.escort_request_by" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width: 25%">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Entered Yard</mat-label>
                                              <input [(ngModel)]="gateDetail.entered_yard" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: left">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Exited Yard</mat-label>
                                              <input [(ngModel)]="gateDetail.exited_yard" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: right">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Escort Location</mat-label>
                                              <input [(ngModel)]="gateDetail.escort_to_location" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Escort Reason</mat-label>
                                              <input [(ngModel)]="gateDetail.escort_reason" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>

                                        <td style="width: 25%;">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Problem Elapsed Time</mat-label>
                                              <input [(ngModel)]="gateDetail.prob_elapsed_time" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: left">
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Total Elapsed Time</mat-label>
                                              <input [(ngModel)]="gateDetail.total_elapsed_time" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%; text-align: right">
                                          <div >
                                            <mat-form-field appearance="outline" style="color: green; font-size: 15px">
                                              <mat-label style="font-size: 18px; color: #E61E00">Stage Id</mat-label>
                                              <input [(ngModel)]="gateDetail.stage_id"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                        <td style="width: 25%">
                                          <div >
                                            <mat-form-field appearance="outline" floatLabel="always" style="color: #E61E00; font-size: 15px">
                                              <mat-label style="font-size: 18px; color: #E61E00">Next Stage Id</mat-label>
                                              <input [(ngModel)]="gateDetail.next_stage_id" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>


                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showDamages">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Gate Damages</div>

                        </div>
                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item4" >
                                    <mat-table  [dataSource]="gdData" multiTemplateDataRows matSort>
                                      <ng-container matColumnDef="damage_component" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Component</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.damage_component}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="damage_type" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.damage_type}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="damage_severity_calc" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Severity</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.damage_severity_calc}}</mat-cell>
                                      </ng-container>
                                      <mat-header-row *matHeaderRowDef="gdColumns; sticky: true"></mat-header-row>
                                      <mat-row   *matRowDef="let row; columns: gdColumns;" class="table-row"></mat-row>
                                    </mat-table>
                                  </div>
                                </td>
                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>


                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showErrorsInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Gate Errors</div>

                        </div>
                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item4" >
                                    <mat-table  [dataSource]="geData" multiTemplateDataRows matSort>
                                      <ng-container matColumnDef="error_description" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Error</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.error_description}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="error_date_fmt" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Created</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.error_date_fmt}}</mat-cell>
                                      </ng-container>
                                      <mat-header-row *matHeaderRowDef="geColumns; sticky: true"></mat-header-row>
                                      <mat-row   *matRowDef="let row; columns: geColumns;" class="table-row"></mat-row>
                                    </mat-table>
                                  </div>
                                </td>
                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>



                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showInspectionInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Inspection Times</div>


                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">
                                  <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid">
                                    <table style="width: 100%; padding-top: 15px">
                                      <tr>
                                        <td style="vertical-align: top">
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='R'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Damages</mat-label>
                                              <input [(ngModel)]="gateDetail.damage_inspection_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='R' && gateDetail.reefer=='1'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">TCIR</mat-label>
                                              <input [(ngModel)]="gateDetail.tcir_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="(gateDetail.transaction_type=='RM' && gateDetail.reefer=='0') ">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Manual Inspection</mat-label>
                                              <input [(ngModel)]="gateDetail.manual_damage_inspection_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type=='RE'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Weight Check</mat-label>
                                              <input [(ngModel)]="gateDetail.weight_check_date" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Chassis Verification</mat-label>
                                              <input [(ngModel)]="gateDetail.chassis_verification_date" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Slot Booth</mat-label>
                                              <input [(ngModel)]="gateDetail.slot_booth_date" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div >
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 18px; color: #E61E00">Slot</mat-label>
                                              <input [(ngModel)]="gateDetail.slot" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D' && gateDetail.reefer=='1'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">TCIR</mat-label>
                                              <input [(ngModel)]="gateDetail.tcir_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type=='DM'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Empty Verification</mat-label>
                                              <input [(ngModel)]="gateDetail.empty_verification_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="(gateDetail.transaction_type=='DI'|| gateDetail.transaction_type=='DE') && gateDetail.seal_verification_date!=' '">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Seals</mat-label>
                                              <input [(ngModel)]="gateDetail.seal_verification_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Damages</mat-label>
                                              <input [(ngModel)]="gateDetail.damage_inspection_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>



                                        <td style="vertical-align: top; text-align: left">
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='R'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Damages By</mat-label>
                                              <input [(ngModel)]="gateDetail.damage_inspection_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='R' && gateDetail.reefer=='1'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">TCIR By</mat-label>
                                              <input [(ngModel)]="gateDetail.tcir_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="(gateDetail.transaction_type=='RM' && gateDetail.reefer=='0') ">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Manual Inspection</mat-label>
                                              <input [(ngModel)]="gateDetail.manual_damage_inspection_by" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type=='RE'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Weight Check By</mat-label>
                                              <input [(ngModel)]="gateDetail.weight_check_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Chassis Verification By</mat-label>
                                              <input [(ngModel)]="gateDetail.chassis_verification_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Slot Booth By</mat-label>
                                              <input [(ngModel)]="gateDetail.slot_booth_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div >
                                            <mat-form-field appearance="outline" floatLabel="always" [className]="gateDetail.strad_status=='PENDING'? 'redFont': 'greenFont' " style="font-weight: 900; font-size: 15px">
                                              <mat-label style="font-size: 18px; color: #E61E00">Straddle Status</mat-label>
                                              <input [(ngModel)]="gateDetail.strad_status"  matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D' && gateDetail.reefer=='1'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">TCIR By</mat-label>
                                              <input [(ngModel)]="gateDetail.tcir_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type=='DM'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Empty Verification By</mat-label>
                                              <input [(ngModel)]="gateDetail.empty_verification_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="(gateDetail.transaction_type=='DI'|| gateDetail.transaction_type=='DE') && gateDetail.seal_verification_date!=' '">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Seals By</mat-label>
                                              <input [(ngModel)]="gateDetail.seal_verification_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Damages By</mat-label>
                                              <input [(ngModel)]="gateDetail.damage_inspection_by" matInput readonly />
                                            </mat-form-field>
                                          </div>

                                        </td>



                                        <td style="vertical-align: top; text-align: right">
                                          <div *ngIf="(gateDetail.transaction_type=='RI' ||gateDetail.transaction_type=='RE') || (gateDetail.transaction_type=='RM' && gateDetail.reefer=='1') ">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Manual Inspection</mat-label>
                                              <input [(ngModel)]="gateDetail.manual_damage_inspection_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>

                                          <div *ngIf="gateDetail.transaction_type=='RM'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Empty Verification</mat-label>
                                              <input [(ngModel)]="gateDetail.empty_verification_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="(gateDetail.transaction_type=='RI'|| gateDetail.transaction_type=='RE') && gateDetail.seal_verification_date!=' ' ">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Seals</mat-label>
                                              <input [(ngModel)]="gateDetail.seal_verification_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='R'">
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Slot Booth</mat-label>
                                              <input [(ngModel)]="gateDetail.slot_booth_date" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Manual Inspection</mat-label>
                                              <input [(ngModel)]="gateDetail.manual_damage_inspection_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">RPM Alarm</mat-label>
                                              <input [(ngModel)]="gateDetail.rpm_alarm_date" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">RPM Inspection</mat-label>
                                              <input [(ngModel)]="gateDetail.rpm_inspection_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Roadability</mat-label>
                                              <input [(ngModel)]="gateDetail.roadability_date" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Red Zone</mat-label>
                                              <input [(ngModel)]="gateDetail.red_zone_date" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                        </td>




                                        <td style="vertical-align: top">
                                          <div *ngIf="(gateDetail.transaction_type=='RI' ||gateDetail.transaction_type=='RE') || (gateDetail.transaction_type=='RM' && gateDetail.reefer=='1') ">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Manual Inspection</mat-label>
                                              <input [(ngModel)]="gateDetail.manual_damage_inspection_by" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type=='RM'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Empty Verification By</mat-label>
                                              <input [(ngModel)]="gateDetail.empty_verification_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="(gateDetail.transaction_type=='RI'|| gateDetail.transaction_type=='RE') && gateDetail.seal_verification_date!=' '">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Seals By</mat-label>
                                              <input [(ngModel)]="gateDetail.seal_verification_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='R'">
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Slot Booth By</mat-label>
                                              <input [(ngModel)]="gateDetail.slot_booth_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Manual Inspection By</mat-label>
                                              <input [(ngModel)]="gateDetail.manual_damage_inspection_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">RPM Alarm By</mat-label>
                                              <input [(ngModel)]="gateDetail.rpm_alarm_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">RPM Inspection By</mat-label>
                                              <input [(ngModel)]="gateDetail.rpm_inspection_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Roadability By</mat-label>
                                              <input [(ngModel)]="gateDetail.roadability_by" matInput readonly />
                                            </mat-form-field>
                                          </div>
                                          <div *ngIf="gateDetail.transaction_type.substr(0,1)=='D'">
                                            <mat-form-field appearance="outline"  >
                                              <mat-label style="font-size: 18px; color: #E61E00">Red Zone By</mat-label>
                                              <input [(ngModel)]="gateDetail.red_zone_by" matInput readonly />
                                            </mat-form-field>
                                          </div>



                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </mat-card>

            </td>
            <td class="loginPic" style="">

            </td>
          </tr>
        </table>

      </mat-card>



    </td>
    <td  [className]="(actionName==null) ? 'mainLowerTd' : 'mainLowerTd2'">

      <mat-card class="speech-bubble" xmlns="http://www.w3.org/1999/html" *ngIf="actionName==null" id="noPrint">
        <div class="truck" style="margin-top: 2%;"></div>
        <div class="titleFont" style="padding-bottom: 10px;">Gate Activity </div>
        <mat-form-field class="myOption2"  appearance="outline">
          <mat-select  [(value)]="savedList" (selectionChange)="wipeOutScreen()" >
            <mat-option  *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div  class="lowerCaseLetters" *ngIf="savedList.toUpperCase()=='VISIT'" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Visits</div>
        <div  class="lowerCaseLetters" *ngIf="savedList.toUpperCase()=='CONTAINER'" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Containers</div>
        <div  class="lowerCaseLetters" *ngIf="savedList.toUpperCase()=='CHASSIS'" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Chassis'</div>
        <div  class="lowerCaseLetters" *ngIf="savedList.toUpperCase()=='BOOKING'" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Bookings</div>
        <div style="padding-left: 3%;">
          <mat-form-field class="newField" appearance="outline" >
            <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
          </mat-form-field>
          <div class="errorDiv2" style="text-align: center" *ngIf=" didntEnterShit">Please Enter A Value</div>
          <div class="errorDiv2" style="text-align: center" *ngIf="badSearch">No Data Found</div>
          <div class="errorDiv2" style="text-align: center" *ngIf=" maherError!=null">{{maherError}}</div>
          <div class="errorDiv2" style="text-align: center" *ngIf=" notANumber">Visit Must Be Numeric</div>
          <div class="errorDiv2" style="text-align: center" *ngIf=" badChars">Invalid Character in {{containerNum}}</div>
          <div class="errorDiv2" style="text-align: center" *ngIf=" badChassis">{{containerNum}} Must Be At Least 4 Alpha; 1 Digit</div>

        </div>
        <mat-toolbar mat-toolbar class="toolbar2">
          <mat-toolbar-row style="justify-content: center">
            <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Search</button>
            <span class="example-fill-remaining-space3"></span>

            <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>

          </mat-toolbar-row>
        </mat-toolbar>
        <div>
          <mat-form-field class="myOption2"  appearance="outline">
            <mat-label>Saved Lists</mat-label>
            <mat-select  [(value)]="savedList2" >
              <mat-option  *ngFor="let lr of savedLists2" [value]="lr.id">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-toolbar class="myToolbar" >
          <mat-toolbar-row style="padding-left: 14%; height: 35px" >
            <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
            <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
            <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
          </mat-toolbar-row>
        </mat-toolbar>
        <mat-toolbar class="myToolbar" style="background-color: white">
          <mat-toolbar-row >
            <mat-form-field  class="myOption" appearance="outline" style="min-width: 77%; max-width: 77%">
              <mat-label>New List</mat-label>
              <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
            </mat-form-field>
            <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
          </mat-toolbar-row>
          <mat-toolbar-row style="height: 26px; justify-content: center">
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertListExists">List Exists For This User</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertNoConts ">List Needs At Least 1 {{savedList}}</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && noListName ">List Name Cannot Be Blank</div>
          </mat-toolbar-row>
        </mat-toolbar>
      </mat-card>

    </td>
  </tr>
</table>





